import flyLogo from '@fly/assets/images/fly_logo.svg';
import classNames from 'classnames';

import styles from './FlyLoader.module.less';

export const FlyLoader = ({ className }: { className?: string }) => {
  // SVG default imports resolve to a URL string under Vite (webapp) but to an
  // ImageMetadata object ({ src, ... }) under Astro (landing-page). Normalize
  // so the same component renders correctly in both build pipelines.
  const asset = flyLogo as unknown as string | { src: string };
  const flyLogoSrc = typeof asset === 'string' ? asset : asset.src;

  return (
    <div
      className={classNames(styles.loaderContainer, className)}
      data-testid='app-loader'
    >
      <div className={styles.wrapper}>
        <img
          src={flyLogoSrc}
          alt='jfrog fly'
          className={classNames('max-w-[48px]')}
        />
        <div className={styles.progressBarWrapper}>
          <div className={styles.progressBar} />
        </div>
      </div>
    </div>
  );
};
